import { render } from "./TournamentScheduleSeniForm.vue?vue&type=template&id=0eda6b4c&scoped=true"
import script from "./TournamentScheduleSeniForm.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleSeniForm.vue?vue&type=script&lang=js"

import "./TournamentScheduleSeniForm.vue?vue&type=style&index=0&id=0eda6b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eda6b4c"]])

export default __exports__